import { IHPITemplateRepository } from "../../adapters/driven/repositories/hpiTemplateRepository";

export const HPITemplateServiceImplFactory = ({
  hpiTemplateRepository,
}: {
  hpiTemplateRepository: IHPITemplateRepository;
}): IHPITemplateService => {
  const createHPITemplate: ICreateHPITemplateService = async (payload) => {
    try {
      const response = await hpiTemplateRepository.createHPITemplateAPI(
        payload
      );

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error("[HPI Template Service] Failed to create template:", error);
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const getHPITemplates: IGetHPITemplatesService = async (payload) => {
    try {
      const response = await hpiTemplateRepository.getHPITemplatesAPI(payload);

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error(
        "[HPI Template Service] Failed to get templates list:",
        error
      );
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const getSingleHPITemplate: IGetSingleHPITemplateService = async (
    payload
  ) => {
    try {
      const response = await hpiTemplateRepository.getSingleHPITemplateAPI(
        payload
      );

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error(
        "[HPI Template Service] Failed to get single template:",
        error
      );
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const updateHPITemplate: IUpdateHPITemplateService = async (payload) => {
    try {
      const response = await hpiTemplateRepository.updateHPITemplateAPI(
        payload
      );

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error("[HPI Template Service] Failed to update template:", error);
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const deleteHPITemplate: IDeleteHPITemplateService = async (payload) => {
    try {
      const response = await hpiTemplateRepository.deleteHPITemplateAPI(
        payload
      );

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error("[HPI Template Service] Failed to delete template:", error);
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  return {
    createHPITemplate,
    getHPITemplates,
    getSingleHPITemplate,
    updateHPITemplate,
    deleteHPITemplate,
  };
};
